export default class Questionnaire {
  constructor() {
    this.questions = {
      1: {
        multiple: false,
        a: true,
        b: false
      },
      2: {
        multiple: false,
        a: false,
        b: true
      },
      3: {
        multiple: true,
        a: false,
        b: false,
        c: false,
        d: true
      },
      4: {
        multiple: false,
        a: true,
        b: false
      },
      5: {
        multiple: true,
        a: true,
        b: true,
        c: true,
        d: true,
        e: false,
        f: false,
        g: false
      }
    }
    this.answers = {}
    for (var key in this.questions) this.answers[key] = []
  }
  get questionList() {
    var qs = []
    for (let q_id in this.questions) {
      var as = []
      for (let a_id in this.questions[q_id]) {
        if (a_id !== 'multiple') as.push(a_id)
      }
      qs.push(as)
    }
    return qs
  }
  setAnswers(q_id, answers) {
    if (answers instanceof Array) this.answers[q_id] = answers
    return this
  }
  clearAllAnswers() {
    for (let q_id in this.questions) {
      this.setAnswers(q_id, [])
    }
  }
  getAnswers(q_id) {
    return this.answers[q_id]
  }
  getCorrectAnswers(q_id) {
    var correctAnswers = []
    for (let a_id in this.questions[q_id]) {
      if (a_id !== 'multiple' && this.questions[q_id][a_id]) correctAnswers.push(a_id)
    }
    return correctAnswers
  }
}


// WEBPACK FOOTER //
// ./src/Questionnaire/Questionnaire.js